import { EResultsActionType } from './types';
import { actionGenerator } from '../../utils/redux/actionGenerator';

export const setDominantSubdomain = actionGenerator<EResultsActionType.SetDominantSubdomain, string>(
  EResultsActionType.SetDominantSubdomain,
);
